import React from 'react';
import { Zap, ShieldCheck, Database, Plug } from 'lucide-react';
import { useScrollTracking } from '../hooks/useScrollTracking';
const features = [{
  icon: Zap,
  title: 'Real-Time Sync',
  description: 'Automatic updates push CAD changes to ERP instantly. No manual exports, no delays, no missed updates.'
}, {
  icon: ShieldCheck,
  title: 'Error-Free Data',
  description: 'Eliminate manual entry mistakes and duplicate records. Guaranteed data accuracy across systems.'
}, {
  icon: Database,
  title: 'Engineering & Business Data',
  description: 'Synchronize your CAD models with your ERP. Connect engineering and business data seamlessly.'
}, {
  icon: Plug,
  title: 'Native Integrations',
  description: 'Direct connectors to SAP, NetSuite, Oracle, Microsoft Dynamics, Thruline, and 20+ ERP systems out of the box.'
}];
export function Features() {
  const sectionRef = useScrollTracking('features');
  return <section ref={sectionRef as any} className="py-24 px-6 bg-white" data-id="element-57">
      <div className="max-w-7xl mx-auto" data-id="element-58">
        <div className="text-center mb-16" data-id="element-59">
          <h2 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-60">
            Built for manufacturing teams
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-61">
            Everything you need to eliminate manual data entry and keep your
            systems in perfect sync.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-62">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="space-y-4" data-id="element-63">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-64">
                  <Icon className="w-6 h-6 text-blue-600" data-id="element-65" />
                </div>
                <h3 className="text-xl font-semibold text-slate-900" data-id="element-66">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-67">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}